import React, {useEffect, useState} from 'react';

import {EventReviewFeedback} from 'src/modules/ai';
import {MIXPANEL_DECORATED_FIELD_NAME} from 'src/modules/ai/constants';
import {HeaderFields} from 'src/modules/event-create/constants';
import {MIXPANEL_DECORATION_INFO} from 'src/modules/event-create/event-create-hovers';
import {HeaderBlock} from 'src/modules/event-create/typedefs';
import {DecorationType} from 'src/openapi/models/DecorationType';
import {EventType} from 'src/openapi/models/EventType';

import {CheckBox} from '@pb/kit-component-checkbox';
import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';

type Props = {
    headerValues: HeaderBlock,
    changeRequestId: number | null,
    onChangeCheckboxField: (data: {event: React.SyntheticEvent<HTMLInputElement>, name: string}) => void,
    onChangeDecorationType: (value: DecorationType | null) => void,
};

export const EventDecoration = (props: Props) => {
    const {
        headerValues,
        changeRequestId,
        onChangeDecorationType,
        onChangeCheckboxField,
    } = props;

    const source = headerValues.source;
    const isDecorated = headerValues.decorated;
    const [isVisible, setIsVisible] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [decorationType, setDecorationType] = useState<DecorationType>();

    useEffect(() => {
        if (source) {
            setIsDisabled(false);
        }
    }, [source]);

    const onCheckBoxChange = (data: {event: React.SyntheticEvent<HTMLInputElement>, name: string}) => {
        onChangeCheckboxField(data);
        if (isDecorated) {
            onChangeDecorationType(null);
            setIsVisible(false);
            setDecorationType(undefined);
        } else {
            setIsVisible(true);
        }
    };

    const onChange = (value: DecorationType) => {
        setDecorationType(value);
        onChangeDecorationType(value);
    };

    return (
        <>
            {headerValues.type === EventType.USER_EVENT && (
                <Group alignItems="center" justify="space-between" gap="s">
                    <Item>
                        <Group gap="xs" alignItems="center" justify="start" className="pdy-m">
                            <CheckBox
                                name={HeaderFields.decorated}
                                disabled={isDisabled}
                                label={<strong>Mixpanel Decorated</strong>}
                                checked={isDecorated}
                                onCheckBoxChange={onCheckBoxChange}
                            />
                            <Dropdown
                                hoverEnabled={true}
                                clickEnabled={false}
                                maxWidth={500}
                                anchor={({anchorRef, getAnchorProps}) => (
                                    <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                )}>
                                {MIXPANEL_DECORATION_INFO}
                            </Dropdown>
                            <EventReviewFeedback
                                changeRequestId={changeRequestId}
                                fieldName={MIXPANEL_DECORATED_FIELD_NAME}
                            />
                        </Group>
                    </Item>
                    {isVisible ? (
                        <Item grow={1}>
                            <ComboBox
                                placeholder="Decoration Template"
                                value={decorationType}
                                onChange={onChange}>
                                {Object.values(DecorationType).map(type =>
                                    <ComboboxItem key={type} value={type} caption={type}/>,
                                )}
                            </ComboBox>
                        </Item>
                    ) : null}
                    <Item style={{width: '1.5rem'}}><span/></Item>
                </Group>
            )}
        </>
    );
};
